import { useLinked } from "@type-r/react";
import { Columns, TilesList } from "lqx-react";
import React from "react";
import { Connection } from "../api/connection";
import { DetailsPaneColumn, TilesListColumn } from "../components/item-card-styles";
import { ConnectionsCardRenderer } from "./connections-card-renderer";
import { ConnectionsDetailsPane } from "./connections-details-pane";

export const ConnectionsList = ({ connections, scrollPagination }: { connections: Connection[], scrollPagination: (e) => void }) => {
    const $activeCard = useLinked<Connection>(null);
    const $selectedTab = useLinked('details');

    return (
        <>
            <Columns style={{ height: 'calc(100% - 80px)' }} onScroll={scrollPagination}>
                <TilesListColumn>
                    <TilesList
                        items={connections}
                        itemSize={100}
                        renderer={ConnectionsCardRenderer($activeCard, $selectedTab)}
                    />
                </TilesListColumn>
                {$activeCard.value &&
                    <DetailsPaneColumn>
                        <ConnectionsDetailsPane $activeCard={$activeCard} $selectedTab={$selectedTab} />
                    </DetailsPaneColumn>}
            </Columns>
        </>
    );
};
